module.exports = __webpack_public_path__ + "static/logo-02d70ccd966db05b26307cfe15d1be57.png";